import React, { useState, useEffect, useRef } from "react";
import leftArrowSvg from "../../../Assets/leftArrowSvg.svg";
import rightArrowSvg from "../../../Assets/rightArrowSvg.svg";
import google_Logo from "../../../Assets/google_Logo.png";
import fb_Logo from "../../../Assets/fb_Logo.png";
import Trivago_Logo from "../../../Assets/Trivago_Logo.png";
import zomato_Logo from "../../../Assets/zomato_Logo.png";
import brand_logo from "../../../Assets/brand_logo.png";
import { Eye, X, SquareUserRound } from "lucide-react";
import Temp1 from "../Templates/temp1";
import Temp2 from "../Templates/temp2";
import badimage from "../../../../src/Assets/negativeExp.png";
import backImage from "../../../../src/Assets/image_13.png";
import backImage2 from "../../../../src/Assets/backImg3.png";
import Temp3 from "../Templates/temp3";
import greatImage from "../../../../src/Assets/PositiveExp.png";

import Modal from "react-bootstrap/Modal";
import {
  get_all_data_onboarding,
  insert_update_business_data_onboarding,
  server_post_data,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import "../../CSS/NewOnboading/Step7.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
export default function Step7Page({ onBack, onNext }) {
  const navigate = useNavigate();
  const [fieldErrors, setFieldErrors] = useState({
    headingText: false,
    subheadingText: false,
    ctaHeading: false,
    ctaText: false,
    ctaHeading1: false,
    ctaText1: false,
    logo: false,
  });
  const [shakeFields, setShakeFields] = useState({
    headingText: false,
    subheadingText: false,
    ctaHeading: false,
    ctaText: false,
    ctaHeading1: false,
    ctaText1: false,
  });

  const [error, setError] = useState(false);

  const [selectedTemplate, setSelectedTemplate] = useState(6);
  const [activeTemplateId, setActiveTemplateId] = useState("6");
  const [logo, setLogo] = useState(null);
  const [headingText, setHeadingText] = useState("Your Feedback Matters!");
  const [BusinessText, setBusinessText] = useState("Business Name");
  const [tagLineText, settagLineText] = useState("Tagline");
  const [subheadingText, setSubheadingText] = useState(
    "Enjoyed your experience? Share your reviews on your favorite platform below!",
  );

  const [ctaHeading, setCtaHeading] = useState("If you had a bad experience!");
  const [ctaHeading1, setCtaHeading1] = useState("Good Experience");
  const [ctaText, setCtaText] = useState("Contact Manager");
  const [ctaText1, setCtaText1] = useState("Needs Improvement");
  const [showModal, setShowModal] = useState(false);
  // Refs for file inputs
  const leftFileInputRef = useRef(null);
  const rightFileInputRef = useRef(null);

  // Handle logo upload
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      setImage(e.target.files[0]);
      reader.onload = (e) => {
        setLogo(e.target.result);
        setFieldErrors((prev) => ({
          ...prev,
          logo: false,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTemplateSelection = (templateId, slideIndex) => {
    setSelectedTemplate(templateId);
    setActiveTemplateId(String(templateId));
    console.log(
      "Selected Template ID:",
      templateId,
      "Slide Index:",
      slideIndex,
    );
    if (swiperRef.current && typeof slideIndex === "number") {
      swiperRef.current.slideTo(slideIndex);
    }
  };

  const handlePreviewMobile = () => {
    setShowModal(!showModal);
  };
  const [image, setImage] = useState([]);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [styles, setStyles] = useState({
    backgroundColor: "#ec5e3a",
    textColor: "#00000",
    ctaColor: "#ff5722",
  });

  const TEMPLATES = [
    {
      id: "6",
      name: "Template 1",
      component: Temp1,
    },
    {
      id: "2",
      name: "Template 2",
      component: Temp2,
    },
    {
      id: "1",
      name: "Template 3",
      component: Temp3,
    },
  ];

  const isLightColor = ({ r, g, b }) => {
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("flag", "7");
    await server_post_data(get_all_data_onboarding, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          if (final_data.onboarding_data.length > 0) {
            setbusinessTypes(final_data.onboarding_data[0]);
            if (
              final_data.onboarding_data[0].heading_text !== "" &&
              final_data.onboarding_data[0].heading_text !== null
            ) {
              setHeadingText(final_data.onboarding_data[0].heading_text);
            }
            if (
              final_data.onboarding_data[0].subheading_text !== "" &&
              final_data.onboarding_data[0].subheading_text !== null
            ) {
              setSubheadingText(final_data.onboarding_data[0].subheading_text);
            }
            if (
              final_data.onboarding_data[0].cta_heading !== "" &&
              final_data.onboarding_data[0].cta_heading !== null
            ) {
              if (final_data.onboarding_data[0].theme_other_id !== "6") {
                setCtaHeading1(final_data.onboarding_data[0].cta_heading);
              } else {
                setCtaHeading(final_data.onboarding_data[0].cta_heading);
              }
            }
            if (
              final_data.onboarding_data[0].cta_text !== "" &&
              final_data.onboarding_data[0].cta_text !== null
            ) {
              if (final_data.onboarding_data[0].theme_other_id !== "6") {
                setCtaText1(final_data.onboarding_data[0].cta_text);
                console.log("In CTA Text 1");
              } else {
                setCtaText(final_data.onboarding_data[0].cta_text);
                console.log("In CTA Text ");
              }
            }
            setLogo(
              final_data.review_linkss_link +
                final_data.onboarding_data[0].website_logo,
            );
            setSelectedTemplate(final_data.onboarding_data[0].theme_other_id);
          }
          setBusinessText(final_data.onboarding_data[0].business_name);
          settagLineText(final_data.onboarding_data[0].business_tagline);
          setbusinessImage(final_data.review_linkss_link);
          setBgColor(final_data.onboarding_data[0].application_color);
          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
          setActiveTemplateId(final_data.onboarding_data[0].theme_other_id);

          setStyles({
            ...styles,
            backgroundColor: final_data.onboarding_data[0].application_color,
            textColor: isLightColor(
              final_data.onboarding_data[0].application_color,
            )
              ? "#000000"
              : "#FFFFFF",
          });
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);
  const validateContentFields = () => {
    const newErrors = {
      headingText: !headingText.trim(),
      subheadingText: !subheadingText.trim(),
      ctaHeading: activeTemplateId === "6" ? !ctaHeading.trim() : false,
      ctaText: activeTemplateId === "6" ? !ctaText.trim() : false,
      ctaHeading1:
        activeTemplateId === "1" || activeTemplateId === "2"
          ? !ctaHeading1.trim()
          : false,
      ctaText1:
        activeTemplateId === "1" || activeTemplateId === "2"
          ? !ctaText1.trim()
          : false,
      logo: !logo,
    };

    setFieldErrors(newErrors);
    Object.entries(newErrors).forEach(([key, val]) => {
      if (val) {
        setShakeFields((prev) => ({ ...prev, [key]: true }));
        setTimeout(() => {
          setShakeFields((prev) => ({ ...prev, [key]: false }));
        }, 400);
      }
    });

    return !Object.values(newErrors).some((val) => val);
  };

  const handleNext = async () => {
    const isValid = validateContentFields();
    if (!isValid) return;

    setError(true);
    setIsLoading(true);

    let fd_from = new FormData();
    fd_from.append("flag", "7");
    fd_from.append("theme_other_id", selectedTemplate);
    fd_from.append("website_logo_old", businessTypes.website_logo);
    fd_from.append("business_name", BusinessText);
    fd_from.append("business_tagline", tagLineText);
    // fd_from.append("website_logo", image); // Uncomment if needed
    fd_from.append("heading_text", headingText);
    fd_from.append("subheading_text", subheadingText);
    fd_from.append("cta_heading", ctaHeading);
    fd_from.append("cta_text", ctaText);

    try {
      const Response = await server_post_data(
        insert_update_business_data_onboarding,
        fd_from,
      );
      setIsLoading(false);

      let data = Response.message.split("~@~");
      const final_data = JSON.parse(data[1]);
      if (parseInt(data[0]) === 1) {
        handleError(final_data.message);
      } else {
        const id = uuidv4();
        const cus_id = uuidv4();
        const sub_id = uuidv4();

        navigate(`/sucees_page?id=${id}&cus_id=${cus_id}&sub_id=${sub_id}`);
        // onNext();
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const renderActiveTemplate = () => {
    // Get the template from our templates object
    const activeTemplate = TEMPLATES.find(
      (template) => template.id === activeTemplateId,
    );

    if (!activeTemplate) {
      console.error(`Template with ID ${activeTemplateId} not found`);
      return null;
    }

    const TemplateComponent = activeTemplate.component;

    let finalCtaHeading = ctaHeading;
    let finalCtatext = ctaText;

    if (activeTemplateId === "2" || activeTemplateId === "1") {
      finalCtaHeading = ctaHeading1;
      finalCtatext = ctaText1;
    } else {
      finalCtaHeading = ctaHeading;
      finalCtatext = ctaText;
    }

    return (
      <TemplateComponent
        logo={logo}
        brand_logo={brand_logo}
        headingText={headingText}
        subheadingText={subheadingText}
        businessTypes2={businessTypes2}
        businessImage2={businessImage2}
        ctaHeading={finalCtaHeading}
        ctaText={finalCtatext}
        styles={styles}
        SquareUserRound={SquareUserRound}
        rightFileInputRef={rightFileInputRef}
      />
    );
  };
  //  carausal Logic
  const carouselRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [angle, setAngle] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      // setIsMobile(width < 768);
      setIsMobile(width < 991);

      // setIsTablet(width >= 768 && width < 991);
      setIsDesktop(width >= 991);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Ensure the active item is centered when activeIndex changes
  useEffect(() => {
    if (activeIndex !== null) {
      const targetAngle = activeIndex * 120;
      setAngle(targetAngle);
    }
  }, [activeIndex]);

  const handleTouchStart = (e) => {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    setStartX(clientX);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - startX;

    // Calculate new angle based on drag distance
    // Negative multiplier for natural feeling (drag right = rotate left)
    const newAngle = angle - deltaX * 0.2;
    setAngle(newAngle);

    // Update active index based on angle
    const normalizedAngle = ((newAngle % 360) + 360) % 360;
    let newActiveIndex;

    if (normalizedAngle >= 300 || normalizedAngle < 60) {
      newActiveIndex = 0;
    } else if (normalizedAngle >= 60 && normalizedAngle < 180) {
      newActiveIndex = 1;
    } else {
      newActiveIndex = 2;
    }

    if (newActiveIndex !== activeIndex) {
      setActiveIndex(newActiveIndex);
    }

    setStartX(clientX);
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;

    setIsDragging(false);

    // Snap to closest item
    const targetAngle = activeIndex * 120;
    setAngle(targetAngle);
  };

  const handleSelect = (index) => {
    setActiveIndex(index);
    setAngle(index * 120);
  };

  const swiperRef = useRef(null);
  useEffect(() => {
    console.log("selectedTemplate changed:", selectedTemplate);
  }, [selectedTemplate]);

  useEffect(() => {
    console.log("activeTemplateId changed:", activeTemplateId);
  }, [activeTemplateId]);

  return (
    <div className="tell_aboutSection step7Container">
      <div className="bussiness_typeCard" style={{ position: "relative" }}>
        <div className="step7Div">
          <div className="height_ovr_flow_clss_step7">
            <div className="row">
              <div className="col-lg-8">
                <div className="customizer-panel">
                  <h1>Customize your feedback page</h1>
                  <div className="scnPageLvl">
                    {" "}
                    <label className="width_clss_abt">
                      Customize your feedback page with themes, layouts, and
                      colors themes that reflect your business personality. Make
                      every customer interaction count from the very first scan.
                    </label>
                  </div>

                  <div className="d-flex gap-2 align-items-center h3HeadScanPage"></div>

                  {/* <div className="logo-bussiness-row">
                  <div className="form-group col-md-3">
                    <label style={{ whiteSpace: "nowrap" }}>Upload Logo</label>
                    <div
                      className={`upload-area ${
                        fieldErrors.logo ? "errorRedBorder" : ""
                      }`}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onClick={() => leftFileInputRef.current.click()}
                    >
                      <input
                        type="file"
                        ref={leftFileInputRef}
                        onChange={handleLogoUpload}
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      {logo ? (
                        <img
                          src={logo || brand_logo}
                          alt="Uploaded Logo"
                          className="uploaded-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = brand_logo;
                          }}
                        />
                      ) : (
                        <div className="upload-placeholder">
                          <i className="upload-icon">📁</i>
                          <p>Drag & Drop your logo here to browse files.</p>
                          <p className="file-info">
                            PNG, JPG or SVG (Max. 2MB)
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tagline-bussinessname col-12">
                    <div className="col-md-6 mb-3">
                      <label>Name of Business</label>
                      <input
                        type="text"
                        className={`form-control  ${
                          fieldErrors.headingText ? "errorRedBorder" : ""
                        }`}
                        value={BusinessText}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const nonSpaceChars = inputValue.replace(/\s/g, "");
                          if (nonSpaceChars.length <= 35) {
                            setBusinessText(inputValue);
                            if (fieldErrors.headingText && inputValue.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                headingText: false,
                              }));
                            }
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Tag Line</label>
                      <input
                        type="text"
                        className={`form-control  ${
                          fieldErrors.headingText ? "errorRedBorder" : ""
                        }`}
                        value={tagLineText}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const nonSpaceChars = inputValue.replace(/\s/g, "");
                          if (nonSpaceChars.length <= 35) {
                            settagLineText(inputValue);
                            if (fieldErrors.headingText && inputValue.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                headingText: false,
                              }));
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
          
                </div> */}
                  {/* Subheading */}
                  <div className="form-group">
                    <label>Select a Template</label>

                    <>
                      <div
                        className="newcutmTemplate"
                        key={selectedTemplate}
                        style={{
                          display: isDesktop ? "flex" : "none",
                          gap: isDesktop ? "1rem" : "0",
                        }}
                      >
                        {/* Template 1 - selectedTemplate === 6 */}
                        <div
                          className={`template-card ${
                            selectedTemplate == 6 ? "selected-template" : ""
                          }`}
                          style={{
                            backgroundImage: `url(${backImage2})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100%",
                          }}
                          onClick={() => handleTemplateSelection(6)}
                        >
                          <div className="underTemplateContent">
                            <div className="text-center mb-4">
                              <div className="wow-logo1 justify-content-center d-inline-flex">
                                <img
                                  src={logo || brand_logo}
                                  alt="Brand Logo"
                                  className="preview-logo"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = brand_logo;
                                  }}
                                />
                              </div>
                            </div>

                            <h2 className="temp1Headtxt">{headingText}</h2>
                            <p className="temp1Subheading">{subheadingText}</p>

                            <div className="temp1bottmData">
                              <img
                                src={google_Logo || "/placeholder.svg"}
                                alt="google"
                              />
                              <img
                                src={fb_Logo || "/placeholder.svg"}
                                alt="Facebook"
                              />
                              <img
                                src={Trivago_Logo || "/placeholder.svg"}
                                alt="Trivago"
                              />
                              <img
                                src={zomato_Logo || "/placeholder.svg"}
                                alt="Zomato"
                              />
                            </div>
                            <p className="template1bottmHeading">
                              {ctaHeading}
                            </p>
                          </div>

                          <button className="ctbtntemplate" type="button">
                            <SquareUserRound className="cta_icnn" />
                            Contact Manager
                          </button>
                        </div>

                        {/* Template 2 - selectedTemplate === 2 */}
                        <div
                          className={`template-card ${
                            selectedTemplate == 2 ? "selected-template" : ""
                          }`}
                          style={{
                            backgroundImage: `url(${backImage})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100%",
                          }}
                          onClick={() => handleTemplateSelection(2)}
                        >
                          <div
                            className="logo-preview mx-auto"
                            style={{
                              marginTop: "10px",
                              border: "1px solid #777",
                              padding: "20px 40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "60px",
                              width: "70px",
                            }}
                          >
                            <input
                              type="file"
                              ref={rightFileInputRef}
                              accept="image/*"
                              style={{ display: "none", cursor: "pointer" }}
                              readOnly
                            />
                            {logo ? (
                              <img
                                src={logo || brand_logo}
                                alt="Brand Logo"
                                className="preview-logo"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = brand_logo;
                                }}
                                style={{
                                  maxWidth: "60px",
                                  maxHeight: "50px",
                                }}
                              />
                            ) : (
                              <div
                                className="logo-placeholder"
                                style={{
                                  color: "#777",
                                  fontSize: "24px",
                                  fontWeight: 500,
                                  letterSpacing: "1px",
                                }}
                              >
                                PLACE LOGO
                              </div>
                            )}
                          </div>

                          <div
                            className="preview-heading"
                            style={{
                              marginTop: "0px",
                              textAlign: "center",
                              fontSize: "16px",
                              fontWeight: 600,
                            }}
                          >
                            {headingText}
                          </div>
                          <div
                            className="preview-subheading"
                            style={{
                              fontSize: "10px",
                              color: "#555",
                              maxWidth: "250px",
                              textAlign: "center",
                              margin: "0px auto",
                            }}
                          >
                            {subheadingText}
                          </div>

                          <div
                            className="social-icons"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "20px",
                              marginTop: "30px",
                              width: "100%",
                              maxWidth: "250px",
                              margin: "30px auto 0",
                            }}
                          >
                            <button
                              className="rating-button positive"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "13px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(240 255 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={greatImage || "/placeholder.svg"}
                                alt="Great Experience"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span style={{ fontSize: "12px" }}>
                                Good Experience
                              </span>
                            </button>

                            <button
                              className="rating-button negative"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "16px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(255 240 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={badimage || "/placeholder.svg"}
                                alt="Needs Improvement"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "14px",
                                }}
                              >
                                Needs Improvement
                              </span>
                            </button>
                          </div>
                        </div>

                        {/* Template 3 - selectedTemplate === 1 */}
                        <div
                          className={`template-card ${
                            selectedTemplate == 1 ? "selected-template" : ""
                          }`}
                          onClick={() => handleTemplateSelection(1)}
                        >
                          <div
                            className="logo-preview mx-auto"
                            style={{
                              marginTop: "10px",
                              border: "1px solid #777",
                              padding: "20px 40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "60px",
                              width: "70px",
                            }}
                          >
                            <input
                              type="file"
                              ref={rightFileInputRef}
                              accept="image/*"
                              style={{ display: "none", cursor: "pointer" }}
                              readOnly
                            />
                            {logo ? (
                              <img
                                src={logo || brand_logo}
                                alt="Brand Logo"
                                className="preview-logo"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = brand_logo;
                                }}
                                style={{
                                  maxWidth: "60px",
                                  maxHeight: "50px",
                                }}
                              />
                            ) : (
                              <div
                                className="logo-placeholder"
                                style={{
                                  color: "#777",
                                  fontSize: "24px",
                                  fontWeight: 500,
                                  letterSpacing: "1px",
                                }}
                              >
                                PLACE LOGO
                              </div>
                            )}
                          </div>

                          <div
                            className="preview-heading"
                            style={{
                              marginTop: "0px",
                              textAlign: "center",
                              fontSize: "16px",
                              fontWeight: 600,
                            }}
                          >
                            {headingText}
                          </div>
                          <div
                            className="preview-subheading"
                            style={{
                              fontSize: "10px",
                              color: "#555",
                              maxWidth: "250px",
                              textAlign: "center",
                              margin: "0px auto",
                            }}
                          >
                            {subheadingText}
                          </div>

                          <div
                            className="social-icons"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "20px",
                              marginTop: "30px",
                              width: "100%",
                              maxWidth: "250px",
                              margin: "30px auto 0",
                            }}
                          >
                            <button
                              className="rating-button positive"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "13px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(240 255 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={greatImage || "/placeholder.svg"}
                                alt="Great Experience"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span style={{ fontSize: "12px" }}>
                                Good Experience
                              </span>
                            </button>

                            <button
                              className="rating-button negative"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "16px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(255 240 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={badimage || "/placeholder.svg"}
                                alt="Needs Improvement"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "14px",
                                }}
                              >
                                Needs Improvement
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>

                    {/* {isTablet && (
                      <>
                        <div
                          className="carousel-container"
                          ref={carouselRef}
                          onTouchStart={handleTouchStart}
                          onTouchMove={handleTouchMove}
                          onTouchEnd={handleTouchEnd}
                          onMouseDown={handleTouchStart}
                          onMouseMove={handleTouchMove}
                          onMouseUp={handleTouchEnd}
                          onMouseLeave={handleTouchEnd}
                        >
                          <div
                            className="carousel-3d"
                            style={{ transform: `rotateY(${angle}deg)` }}
                          >
                            <div
                              className={`carousel-item ${
                                activeIndex === 0 ? "active" : ""
                              }`}
                              onClick={() => handleSelect(0)}
                            >
                              <div
                                className={`template-card ${
                                  selectedTemplate === 1
                                    ? "selected-template"
                                    : ""
                                }`}
                                style={{
                                  backgroundImage: `url(${backImage2})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "100%",
                                }}
                                onClick={() => handleTemplateSelection(6)}
                              >
                                <div className="underTemplateContent">
                                  <div className="text-center mb-4">
                                    <div className="wow-logo1 justify-content-center d-inline-flex">
                                      <img
                                        src={logo || brand_logo}
                                        alt="Brand Logo"
                                        className="preview-logo"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = brand_logo;
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <h2 className="temp1Headtxt">
                                    {headingText}
                                  </h2>
                                  <p className="temp1Subheading">
                                    {subheadingText}
                                  </p>
                                  <p className="template1bottmHeading">
                                    {ctaHeading}
                                  </p>
                                  <div className="temp1bottmData">
                                    <img
                                      src={google_Logo || "/placeholder.svg"}
                                      alt="google"
                                      title="google"
                                    />
                                    <img
                                      src={fb_Logo || "/placeholder.svg"}
                                      alt="Facebook"
                                      title="Facebook"
                                    />
                                    <img
                                      src={Trivago_Logo || "/placeholder.svg"}
                                      alt="Trivago"
                                      title="Trivago"
                                    />
                                    <img
                                      src={zomato_Logo || "/placeholder.svg"}
                                      alt="Zomato"
                                      title="Zomato"
                                    />
                                  </div>
                                </div>
                                <button className="ctbtntemplate" type="button">
                                  <img
                                    src={server_person || "/placeholder.svg"}
                                    className="cta_icnn"
                                    alt="person icon"
                                  />
                                  Contact Manager
                                </button>
                              </div>
                            </div>
                            <div
                              className={`carousel-item ${
                                activeIndex === 1 ? "active" : ""
                              }`}
                              onClick={() => handleSelect(1)}
                            >
                              <div
                                className={`template-card ${
                                  selectedTemplate === 2
                                    ? "selected-template"
                                    : ""
                                }`}
                                style={{
                                  backgroundImage: `url(${backImage})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "100%",
                                }}
                                onClick={() => handleTemplateSelection(2)}
                              >
                                <div
                                  className="logo-preview mx-auto"
                                  style={{
                                    marginTop: "10px",
                                    border: "1px solid #777",
                                    padding: "20px 40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                    width: "70px",
                                  }}
                                >
                                  <input
                                    type="file"
                                    ref={rightFileInputRef}
                                    accept="image/*"
                                    style={{
                                      display: "none",
                                      cursor: "pointer",
                                    }}
                                    readOnly
                                  />
                                  {logo ? (
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = brand_logo;
                                      }}
                                      style={{
                                        maxWidth: "60px",
                                        maxHeight: "50px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="logo-placeholder"
                                      style={{
                                        color: "#777",
                                        fontSize: "24px",
                                        fontWeight: 500,
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      PLACE LOGO
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="preview-heading"
                                  style={{
                                    marginTop: "0px",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {headingText}
                                </div>
                                <div
                                  className="preview-subheading"
                                  style={{
                                    fontSize: "10px",
                                    color: "#555",
                                    maxWidth: "250px",
                                    textAlign: "center",
                                    margin: "0px auto",
                                  }}
                                >
                                  {subheadingText}
                                </div>

                                <div
                                  className="social-icons"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    marginTop: "30px",
                                    width: "100%",
                                    maxWidth: "250px",
                                    margin: "30px auto 0",
                                  }}
                                >
                                  <button
                                    className="rating-button positive"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "13px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(240 255 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={greatImage || "/placeholder.svg"}
                                      alt="Great Experience"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span style={{ fontSize: "12px" }}>
                                      Good Experience
                                    </span>
                                  </button>

                                  <button
                                    className="rating-button negative"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(255 240 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={badimage || "/placeholder.svg"}
                                      alt="Needs Improvement"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "14px",
                                      }}
                                    >
                                      Needs Improvement
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`carousel-item ${
                                activeIndex === 2 ? "active" : ""
                              }`}
                              onClick={() => handleSelect(2)}
                            >
                              <div
                                className={`template-card ${
                                  selectedTemplate === 3
                                    ? "selected-template"
                                    : ""
                                }`}
                                onClick={() => handleTemplateSelection(1)}
                              >
                                <div
                                  className="logo-preview mx-auto"
                                  style={{
                                    marginTop: "10px",
                                    border: "1px solid #777",
                                    padding: "20px 40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                    width: "70px",
                                  }}
                                >
                                  <input
                                    type="file"
                                    ref={rightFileInputRef}
                                    accept="image/*"
                                    style={{
                                      display: "none",
                                      cursor: "pointer",
                                    }}
                                    readOnly
                                  />
                                  {logo ? (
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = brand_logo;
                                      }}
                                      style={{
                                        maxWidth: "60px",
                                        maxHeight: "50px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="logo-placeholder"
                                      style={{
                                        color: "#777",
                                        fontSize: "24px",
                                        fontWeight: 500,
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      PLACE LOGO
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="preview-heading"
                                  style={{
                                    marginTop: "0px",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {headingText}
                                </div>
                                <div
                                  className="preview-subheading"
                                  style={{
                                    fontSize: "10px",
                                    color: "#555",
                                    maxWidth: "250px",
                                    textAlign: "center",
                                    margin: "0px auto",
                                  }}
                                >
                                  {subheadingText}
                                </div>

                                <div
                                  className="social-icons"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    marginTop: "30px",
                                    width: "100%",
                                    maxWidth: "250px",
                                    margin: "30px auto 0",
                                  }}
                                >
                                  <button
                                    className="rating-button positive"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "13px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(240 255 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={greatImage || "/placeholder.svg"}
                                      alt="Great Experience"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span style={{ fontSize: "12px" }}>
                                      Good Experience
                                    </span>
                                  </button>

                                  <button
                                    className="rating-button negative"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(255 240 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={badimage || "/placeholder.svg"}
                                      alt="Needs Improvement"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "14px",
                                      }}
                                    >
                                      Needs Improvement
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="carousel-dots">
                            <span
                              className={`dot ${
                                activeIndex === 0 ? "active" : ""
                              }`}
                              onClick={() => handleSelect(0)}
                            />
                            <span
                              className={`dot ${
                                activeIndex === 1 ? "active" : ""
                              }`}
                              onClick={() => handleSelect(1)}
                            />
                            <span
                              className={`dot ${
                                activeIndex === 2 ? "active" : ""
                              }`}
                              onClick={() => handleSelect(2)}
                            />
                          </div>
                        </div>
                      </>
                    )} */}
                  </div>

                  <div
                    className="swiper-container"
                    style={{ display: isMobile ? "block" : "none" }}
                  >
                    <Swiper
                      onSwiper={(swiper) => (swiperRef.current = swiper)}
                      centeredSlides={true}
                      centeredSlidesBounds={true}
                      spaceBetween={20}
                      pagination={{ clickable: true }}
                      navigation={true}
                      autoplay={false}
                      modules={[Pagination, Navigation]}
                      className="template-swiper"
                      style={{ padding: "0 5%" }}
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                          spaceBetween: 10,
                        },
                        500: {
                          slidesPerView: 1.5,
                          spaceBetween: 10,
                        },
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        992: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                      }}
                    >
                      <SwiperSlide
                        onClick={() => handleTemplateSelection(6, 0)}
                      >
                        <div
                          className={`template-card ${
                            selectedTemplate == 6 ? "selected-template" : ""
                          }`}
                          style={{
                            backgroundImage: `url(${backImage2})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100%",
                          }}
                        >
                          <div className="underTemplateContent">
                            <div className="text-center mb-4">
                              <div className="wow-logo1 justify-content-center d-inline-flex">
                                <img
                                  src={logo || brand_logo}
                                  alt="Brand Logo"
                                  className="preview-logo"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = brand_logo;
                                  }}
                                />
                              </div>
                            </div>

                            <h2 className="temp1Headtxt">{headingText}</h2>
                            <p className="temp1Subheading">{subheadingText}</p>

                            <div className="temp1bottmData">
                              <img
                                src={google_Logo || "/placeholder.svg"}
                                alt="google"
                                title="google"
                              />
                              <img
                                src={fb_Logo || "/placeholder.svg"}
                                alt="Facebook"
                                title="Facebook"
                              />
                              <img
                                src={Trivago_Logo || "/placeholder.svg"}
                                alt="Trivago"
                                title="Trivago"
                              />
                              <img
                                src={zomato_Logo || "/placeholder.svg"}
                                alt="Zomato"
                                title="Zomato"
                              />
                            </div>
                            <p className="template1bottmHeading">
                              {ctaHeading}
                            </p>
                          </div>
                          <button className="ctbtntemplate" type="button">
                            <SquareUserRound className="cta_icnn" />
                            Contact Manager
                          </button>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide
                        onClick={() => handleTemplateSelection(2, 1)}
                      >
                        <div
                          className={`template-card ${
                            selectedTemplate == 2 ? "selected-template" : ""
                          }`}
                          style={{
                            backgroundImage: `url(${backImage})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100%",
                          }}
                        >
                          <div
                            className="logo-preview mx-auto"
                            style={{
                              marginTop: "10px",
                              border: "1px solid #777",
                              padding: "20px 40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "60px",
                              width: "70px",
                            }}
                          >
                            <input
                              type="file"
                              ref={rightFileInputRef}
                              accept="image/*"
                              style={{ display: "none", cursor: "pointer" }}
                              readOnly
                            />
                            {logo ? (
                              <img
                                src={logo || brand_logo}
                                alt="Brand Logo"
                                className="preview-logo"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = brand_logo;
                                }}
                                style={{
                                  maxWidth: "60px",
                                  maxHeight: "50px",
                                }}
                              />
                            ) : (
                              <div
                                className="logo-placeholder"
                                style={{
                                  color: "#777",
                                  fontSize: "24px",
                                  fontWeight: 500,
                                  letterSpacing: "1px",
                                }}
                              >
                                PLACE LOGO
                              </div>
                            )}
                          </div>

                          <div
                            className="preview-heading"
                            style={{
                              marginTop: "0px",
                              textAlign: "center",
                              fontSize: "16px",
                              fontWeight: 600,
                            }}
                          >
                            {headingText}
                          </div>
                          <div
                            className="preview-subheading"
                            style={{
                              fontSize: "10px",
                              color: "#555",
                              maxWidth: "250px",
                              textAlign: "center",
                              margin: "0px auto",
                            }}
                          >
                            {subheadingText}
                          </div>

                          <div
                            className="social-icons"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "20px",
                              marginTop: "30px",
                              width: "100%",
                              maxWidth: "250px",
                              margin: "30px auto 0",
                            }}
                          >
                            <button
                              className="rating-button positive"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "13px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(240 255 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={greatImage || "/placeholder.svg"}
                                alt="Great Experience"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span style={{ fontSize: "12px" }}>
                                Good Experience
                              </span>
                            </button>

                            <button
                              className="rating-button negative"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "16px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(255 240 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={badimage || "/placeholder.svg"}
                                alt="Needs Improvement"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "14px",
                                }}
                              >
                                Needs Improvement
                              </span>
                            </button>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide
                        onClick={() => handleTemplateSelection(1, 2)}
                      >
                        <div
                          className={`template-card ${
                            selectedTemplate == 1 ? "selected-template" : ""
                          }`}
                        >
                          <div
                            className="logo-preview mx-auto"
                            style={{
                              marginTop: "10px",
                              border: "1px solid #777",
                              padding: "20px 40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "60px",
                              width: "70px",
                            }}
                          >
                            <input
                              type="file"
                              ref={rightFileInputRef}
                              accept="image/*"
                              style={{ display: "none", cursor: "pointer" }}
                              readOnly
                            />
                            {logo ? (
                              <img
                                src={logo || brand_logo}
                                alt="Brand Logo"
                                className="preview-logo"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = brand_logo;
                                }}
                                style={{
                                  maxWidth: "60px",
                                  maxHeight: "50px",
                                }}
                              />
                            ) : (
                              <div
                                className="logo-placeholder"
                                style={{
                                  color: "#777",
                                  fontSize: "24px",
                                  fontWeight: 500,
                                  letterSpacing: "1px",
                                }}
                              >
                                PLACE LOGO
                              </div>
                            )}
                          </div>

                          <div
                            className="preview-heading"
                            style={{
                              marginTop: "0px",
                              textAlign: "center",
                              fontSize: "16px",
                              fontWeight: 600,
                            }}
                          >
                            {headingText}
                          </div>
                          <div
                            className="preview-subheading"
                            style={{
                              fontSize: "10px",
                              color: "#555",
                              maxWidth: "250px",
                              textAlign: "center",
                              margin: "0px auto",
                            }}
                          >
                            {subheadingText}
                          </div>

                          <div
                            className="social-icons"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "20px",
                              marginTop: "30px",
                              width: "100%",
                              maxWidth: "250px",
                              margin: "30px auto 0",
                            }}
                          >
                            <button
                              className="rating-button positive"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "13px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(240 255 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={greatImage || "/placeholder.svg"}
                                alt="Great Experience"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                Good Experience
                              </span>
                            </button>

                            <button
                              className="rating-button negative"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                borderRadius: "30px",
                                border: "none",
                                fontSize: "16px",
                                fontWeight: 500,
                                cursor: "pointer",
                                backgroundColor: "rgb(255 240 240)",
                                color: "#333",
                              }}
                            >
                              <img
                                src={badimage || "/placeholder.svg"}
                                alt="Needs Improvement"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "10px",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "14px",
                                }}
                              >
                                Needs Improvement
                              </span>
                            </button>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>

                  {/* Heading Text */}
                  <div className="form-group">
                    <div className="w-100 d-flex justify-content-between align-items-center">
                      <label>Heading Text</label>
                      <div
                        style={{
                          fontSize: "12px",
                          color:
                            headingText.replace(/\s/g, "").length >= 25
                              ? "red"
                              : "green",
                        }}
                      >
                        {headingText.replace(/\s/g, "").length} / 25
                      </div>
                    </div>

                    <input
                      type="text"
                      className={`form-control ${
                        fieldErrors.headingText ? "errorRedBorder" : ""
                      } ${shakeFields.headingText ? "shake" : ""}`}
                      value={headingText}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const nonSpaceChars = inputValue.replace(/\s/g, "");
                        if (nonSpaceChars.length <= 25) {
                          setHeadingText(inputValue);
                          if (fieldErrors.headingText && inputValue.trim()) {
                            setFieldErrors((prev) => ({
                              ...prev,
                              headingText: false,
                            }));
                          }
                        } else {
                          setShakeFields((prev) => ({
                            ...prev,
                            headingText: true,
                          }));
                          setTimeout(
                            () =>
                              setShakeFields((prev) => ({
                                ...prev,
                                headingText: false,
                              })),
                            400,
                          );
                        }
                      }}
                    />

                    {fieldErrors.headingText && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        Please enter heading text
                      </span>
                    )}
                  </div>

                  {/* Subheading */}
                  <div className="form-group">
                    <div className="w-100 d-flex justify-content-between align-items-center">
                      <label>Subheading</label>
                      <div
                        style={{
                          fontSize: "12px",
                          color:
                            subheadingText.replace(/\s/g, "").length >= 70
                              ? "red"
                              : "green",
                        }}
                      >
                        {subheadingText.replace(/\s/g, "").length} / 70
                      </div>
                    </div>

                    <input
                      type="text"
                      className={`form-control ${
                        fieldErrors.subheadingText ? "errorRedBorder" : ""
                      } ${shakeFields.subheadingText ? "shake" : ""}`}
                      value={subheadingText}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const nonSpaceChars = inputValue.replace(/\s/g, "");
                        if (nonSpaceChars.length <= 70) {
                          setSubheadingText(inputValue);
                          if (fieldErrors.subheadingText && inputValue.trim()) {
                            setFieldErrors((prev) => ({
                              ...prev,
                              subheadingText: false,
                            }));
                          }
                        } else {
                          setShakeFields((prev) => ({
                            ...prev,
                            subheadingText: true,
                          }));
                          setTimeout(
                            () =>
                              setShakeFields((prev) => ({
                                ...prev,
                                subheadingText: false,
                              })),
                            400,
                          );
                        }
                      }}
                    />

                    {fieldErrors.subheadingText && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        Please enter subheading
                      </span>
                    )}
                  </div>

                  {/* CTA Heading */}
                  {activeTemplateId === "6" && (
                    <div className="form-group">
                      <div className="w-100 d-flex justify-content-between align-items-center">
                        <label>CTA Heading</label>
                        <div
                          style={{
                            fontSize: "12px",
                            color:
                              ctaHeading.replace(/\s/g, "").length >= 30
                                ? "red"
                                : "green",
                          }}
                        >
                          {ctaHeading.replace(/\s/g, "").length} / 30
                        </div>
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          fieldErrors.ctaHeading ? "errorRedBorder" : ""
                        } ${shakeFields.ctaHeading ? "shake" : ""}`}
                        value={ctaHeading}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const nonSpaceChars = inputValue.replace(/\s/g, "");
                          if (nonSpaceChars.length <= 30) {
                            setCtaHeading(inputValue);
                            if (fieldErrors.ctaHeading && inputValue.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                ctaHeading: false,
                              }));
                            }
                          } else {
                            setShakeFields((prev) => ({
                              ...prev,
                              ctaHeading: true,
                            }));
                            setTimeout(
                              () =>
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaHeading: false,
                                })),
                              400,
                            );
                          }
                        }}
                      />

                      {fieldErrors.ctaHeading && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          Please enter CTA heading
                        </span>
                      )}
                    </div>
                  )}

                  {(activeTemplateId === "1" || activeTemplateId === "2") && (
                    <div className="form-group">
                      <div className="w-100 d-flex justify-content-between align-items-center">
                        <label>Option One</label>
                        <div
                          style={{
                            fontSize: "12px",
                            color:
                              ctaHeading1.replace(/\s/g, "").length >= 30
                                ? "red"
                                : "green",
                          }}
                        >
                          {ctaHeading1.replace(/\s/g, "").length} / 30
                        </div>
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          fieldErrors.ctaHeading1 ? "errorRedBorder" : ""
                        } ${shakeFields.ctaHeading1 ? "shake" : ""}`}
                        value={ctaHeading1}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const nonSpaceChars = inputValue.replace(/\s/g, "");
                          if (nonSpaceChars.length <= 30) {
                            setCtaHeading1(inputValue);
                            setCtaHeading(inputValue);
                            if (fieldErrors.ctaHeading1 && inputValue.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                ctaHeading1: false,
                              }));
                            }
                          } else {
                            setShakeFields((prev) => ({
                              ...prev,
                              ctaHeading1: true,
                            }));
                            setTimeout(
                              () =>
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaHeading1: false,
                                })),
                              400,
                            );
                          }
                        }}
                      />

                      {fieldErrors.ctaHeading1 && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          Please enter Option One
                        </span>
                      )}
                    </div>
                  )}

                  {/* CTA Text */}
                  {activeTemplateId === "6" && (
                    <div className="form-group">
                      <div className="w-100 d-flex justify-content-between align-items-center">
                        <label>CTA Text</label>
                        <div
                          style={{
                            fontSize: "12px",
                            color:
                              ctaText.replace(/\s/g, "").length >= 25
                                ? "red"
                                : "green",
                          }}
                        >
                          {ctaText.replace(/\s/g, "").length} / 25
                        </div>
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          fieldErrors.ctaText ? "errorRedBorder" : ""
                        } ${shakeFields.ctaText ? "shake" : ""}`}
                        value={ctaText}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const nonSpaceChars = inputValue.replace(/\s/g, "");
                          if (nonSpaceChars.length <= 25) {
                            setCtaText(inputValue);
                            if (fieldErrors.ctaText && inputValue.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                ctaText: false,
                              }));
                            }
                          } else {
                            setShakeFields((prev) => ({
                              ...prev,
                              ctaText: true,
                            }));
                            setTimeout(
                              () =>
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaText: false,
                                })),
                              400,
                            );
                          }
                        }}
                      />

                      {fieldErrors.ctaText && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          Please enter CTA text
                        </span>
                      )}
                    </div>
                  )}

                  {(activeTemplateId === "1" || activeTemplateId === "2") && (
                    <div className="form-group">
                      <div className="w-100 d-flex justify-content-between align-items-center">
                        <label>Option Two</label>
                        <div
                          style={{
                            fontSize: "12px",
                            color:
                              ctaText1.replace(/\s/g, "").length >= 30
                                ? "red"
                                : "green",
                          }}
                        >
                          {ctaText1.replace(/\s/g, "").length} / 30
                        </div>
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          fieldErrors.ctaText1 ? "errorRedBorder" : ""
                        } ${shakeFields.ctaText1 ? "shake" : ""}`}
                        value={ctaText1}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const nonSpaceChars = inputValue.replace(/\s/g, "");
                          if (nonSpaceChars.length <= 30) {
                            setCtaText1(inputValue);
                            setCtaText(inputValue);
                            if (fieldErrors.ctaText1 && inputValue.trim()) {
                              setFieldErrors((prev) => ({
                                ...prev,
                                ctaText1: false,
                              }));
                            }
                          } else {
                            setShakeFields((prev) => ({
                              ...prev,
                              ctaText1: true,
                            }));
                            setTimeout(
                              () =>
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaText1: false,
                                })),
                              400,
                            );
                          }
                        }}
                      />

                      {fieldErrors.ctaText1 && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          Please enter Option Two
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="col-lg-4 hidden_mobile">
              <div className="preview-panel">

                <div className="mobile-frame">
                  <div className="mobile-content">

                    <div
                      className="logo-preview"
                      onClick={() => rightFileInputRef.current.click()}
                    >
                      <input
                        type="file"
                        ref={rightFileInputRef}

                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      {logo ? (
                        <img
                          src={logo || brand_logo}
                          alt="Brand Logo"
                          className="preview-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = brand_logo;
                          }}
                        />
                      ) : (
                        <>
                          <div className="logo-placeholder">
                            <img
                              src={brand_logo}
                              className="brand_logo"
                              alt="brand_logo"
                            ></img>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="preview-heading">{headingText}</div>

                    <div className="preview-subheading">{subheadingText}</div>

                    <div className="social-icons">
                      {businessTypes2.map((item, index) => {
                        if (index < 4) {
                          return (
                            <img
                              key={index}
                              src={businessImage2 + item.review_logo}
                              alt={item.review_name}
                              title={item.review_name}
                            ></img>
                          );
                        }
                      })}
                    </div>

                    <div className="preview-cta-section">
                      <div
                        className="preview-cta-heading"
                        style={{ color: "var(--black)" }}
                      >
                        {ctaHeading}
                      </div>
                      <button
                        className="preview-cta-button"
                        style={{
                          backgroundColor: styles.backgroundColor,
                          color: styles.textColor,
                        }}
                      >
                        <img
                          src={server_person}
                          className="cta_icnn"
                          alt="icon"
                        />
                        {ctaText}
                      </button>
                    </div>
                    <div className="preview-footer">
                      Powered by Your <span>Wowreviews</span>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
              {/* <Temp1
              logo={logo}
              brand_logo={brand_logo}
              headingText={headingText}
              subheadingText={subheadingText}
              businessTypes2={businessTypes2}
              businessImage2={businessImage2}
              ctaHeading={ctaHeading}
              ctaText={ctaText}
              styles={styles}
              server_person={server_person}
              rightFileInputRef={rightFileInputRef}
            /> */}
              {renderActiveTemplate()}
              {/* <Temp2
              logo={logo}
              brand_logo={brand_logo}
              headingText={headingText}
              subheadingText={subheadingText}
              businessTypes2={businessTypes2}
              businessImage2={businessImage2}
              ctaHeading={ctaHeading}
              ctaText={ctaText}
              styles={styles}
              server_person={server_person}
              rightFileInputRef={rightFileInputRef}
            /> */}
            </div>
          </div>
        </div>
        <div className="mobilePreviewContainer">
          <button
            type="button"
            className="mobilePreviews"
            onClick={handlePreviewMobile}
          >
            <Eye size={16} />
          </button>{" "}
          <p>Preview</p>
        </div>
        <div className="pre_next_bttn_div">
          <button className="prevBtn" onClick={onBack}>
            <img
              src={leftArrowSvg}
              alt="left"
              title="left"
              className="leftArrowSvg"
            />
            Back
          </button>
          <button className="nextBtn" onClick={handleNext}>
            Next
            <img
              src={rightArrowSvg}
              alt="right"
              title="right"
              className="right_arrw_svg"
            />
          </button>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={handlePreviewMobile}
        centered
        backdrop="static"
      >
        <Modal.Body style={{ position: "relative" }}>
          <X
            size={25}
            onClick={handlePreviewMobile}
            className="close_model_div"
          />

          <div className="step7Div modal_step_7  ">
            {renderActiveTemplate()}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
